module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-2.35e6ebe9.jpg";